import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    Search,
    Grid,
} from '@deere/fuel-react';
import React, { useContext, useState } from 'react';
import { PropTypes } from 'prop-types';
import searchIcon from '@deere/ux.brand-foundations/icons/search.svg';
import { LoggedInContext } from '../../context/LoggedInContext';
import { errorBannerFromResponse } from '../../utils/errorBanner';

export const AddBidderModal = ({
    jobNumber,
    modalIsOpen,
    addBidderToJob,
    closeModal,
}) => {
    const [isSearchClicked, setIsSearchClicked] = useState(false);
    const [errorFromAPI, setErrorFromAPI] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [racfId, setRacfId] = useState('');
    const [jobBidder, setJobBidder] = useState(null);
    const { makeRequest } = useContext(LoggedInContext);

    const searchHandler = async () => {
        const response = await makeRequest(
            `${process.env.REACT_APP_API_ENDPOINT}/employee/${racfId}`
        );
        if (response.status === 200) {
            const responseData = await response.json();
            setJobBidder({
                name: responseData.firstName + ' ' + responseData.lastName,
                unit: responseData.location,
                dept: responseData.custom05,
                classification: responseData.occupationalLevelsNav
                    ? responseData.occupationalLevelsNav.externalCode
                    : '',
                racf: racfId.toLowerCase(),
                status: 'SUBMITTED',
                jobNumber,
            });
            setErrorFromAPI(false);
            setErrorMessage(null);
        } else if (response.status === 404) {
            setErrorFromAPI(true);
            setErrorMessage(null);
        } else {
            setErrorFromAPI(true);
            setErrorMessage(
                errorBannerFromResponse(
                    response,
                    'We are unable to search for this employee. Please try again later.'
                ).message
            );
        }
    };

    const handleChange = (event) => {
        setRacfId(event.target.value);
        setIsSearchClicked(true);
        setErrorFromAPI(false);
        setErrorMessage(null);
        setJobBidder(null);
    };
    const handleClear = (event) => {
        setRacfId('');
        setJobBidder(null);
    };

    return (
        <Modal
            open={modalIsOpen}
            onClose={closeModal}
            maxWidth="xs"
            fullWidth={true}
        >
            <ModalTitle>Add Employee Bid</ModalTitle>
            <ModalContent>
                *RACF ID
                <Grid container>
                    <Grid item xs={6} paddingRight="1rem">
                        <Search
                            placeholder="AB231EF"
                            value={racfId}
                            onChange={handleChange}
                            onClick={(event) => setIsSearchClicked(true)}
                            onClear={handleClear}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            onClick={searchHandler}
                            variant="secondary"
                            startIcon={<img alt=">>" src={searchIcon} />}
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
                {isSearchClicked && !errorFromAPI && jobBidder !== null && (
                    <Grid container>
                        <Grid item xs={12} paddingTop="1rem">
                            <b>{jobBidder.name}</b>
                        </Grid>
                        <Grid item xs={12}>
                            Unit: {jobBidder.unit}
                        </Grid>
                        <Grid item xs={6}>
                            Department: {jobBidder.dept}
                        </Grid>
                    </Grid>
                )}
                {errorFromAPI && jobBidder === null && (
                    <Grid container>
                        <Grid item xs={12} paddingTop="1rem">
                            <b>
                                {errorMessage ??
                                    'There are no employee matches to the RACF ID number entered.'}
                            </b>
                        </Grid>
                    </Grid>
                )}
            </ModalContent>
            <ModalActions>
                <Button onClick={closeModal} variant="secondary">
                    Cancel
                </Button>
                <Button
                    onClick={() => addBidderToJob(jobBidder)}
                    disabled={errorFromAPI || jobBidder === null}
                    variant="primary"
                >
                    Add To Bid List
                </Button>
            </ModalActions>
        </Modal>
    );
};

AddBidderModal.propTypes = {
    jobNumber: PropTypes.string,
    modalIsOpen: PropTypes.bool.isRequired,
    addBidderToJob: PropTypes.func,
    closeModal: PropTypes.func,
};
